import { StyleSheet, View, Image, Text, TouchableOpacity, ImageBackground } from 'react-native';
import { useEffect, useState } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";

            



const Drinks = [
    {
        img: require('../assets/screens/1-q.png'),
        img2: require('../assets/screens/1-o.png'),
    },
    {
        img: require('../assets/screens/2-q.png'),
        img2: require('../assets/screens/2-o.png'),
    },
    {
        img: require('../assets/screens/3-q.png'),
        img2: require('../assets/screens/3-o.png'),
    },
    {
        img: require('../assets/screens/4-q.png'),
        img2: require('../assets/screens/4-o.png'),
    },
    {
        img: require('../assets/screens/5-q.png'),
        img2: require('../assets/screens/5-o.png'),
    },
    {
        img: require('../assets/screens/6-q.png'),
        img2: require('../assets/screens/6-o.png'),
    },
    ]

const Wrong = ({ onOpen, selectedNo}: {
    onOpen(): void,
  selectedNo: number,}) => {
  
  const selectDrink = Drinks[selectedNo -1];;
  return <View style={styles.container}>
      <View  style={{...styles.logoW, backgroundColor: '#099b43'}}>

      <Image
        style={styles.logo}
        resizeMode="contain"
        resizeMethod="resize"
        source={require('../assets/logo.png')}
      />
    </View>
    <View  style={styles.containerQuiz}>


<View style={styles.quizView}>
    <View style={styles.imgInfo}>
<Image
             style={styles.imgInfoAbsolute}
             resizeMode="contain"
             resizeMethod="scale"
             source={selectDrink.img2}
           />

</View>



</View>

    </View>
    <View  style={styles.containerLast}>
     <TouchableOpacity
          style={styles.button}
          onPress={() => {
            onOpen();
          }}
        >
          <Text style={styles.buttonText}>încearcă din nou</Text>
        </TouchableOpacity>

        <Image
          style={{
            ...styles.centerImage,
            height: 74,
            width: 627
          }}
          resizeMode="contain"
          resizeMethod="resize"
          source={require('../assets/cups.png')}
        />
  
    </View>
  </View>
}

const styles = StyleSheet.create({
    container: {
      width:'100%',
      minHeight:1280,
      backgroundColor: '#b8cd70',
    },
    containerQuiz:{
        width:'100%',
        minHeight:750,
        backgroundColor: '#fff',
    },
    logoW:{
  
        },
            logo:{
     alignSelf: 'center',
    width: 800,
    height:126,
    },
    containerw:{
      position:'relative',
      width:'100%',
      zIndex: 1,
    },
   
    centerImage:{
      alignSelf: 'center',
    },
    imgInfo:{
        height: 700,
        position: 'relative',
        width: '100%',
    },
    imgInfoAbsolute:{
        height: 781,
        position: 'absolute',
        top: 0,
        width:  606,
        left: '50%',
        marginLeft: -303,
      zIndex: 1,
    },
    quizView:{
        alignItems:'flex-start',
        flex:1,
        marginTop: 60,
        marginBottom: 5,
        flexDirection: 'row',
      },
     
    containerLast:{
        backgroundColor:'#b8cd70',
         width:'100%',
         zIndex: 2,
         position:'relative',
         flexDirection: 'column',
         marginTop: '10%',
     },
     button:{
        backgroundColor:'#00a547',
        borderRadius: 7,
        alignSelf: 'center',
        flex:1,
        width:420,
        height: 60,
        lineHeight: 50,
        marginTop:'10%',
        marginBottom:'9%',
        alignItems:'center',
        justifyContent:'center',
      },
      buttonText:{
        fontSize: 42,
        color: '#fff',
        fontWeight: 'bold',
        alignSelf: 'center',
        paddingBottom:'0%',
        lineHeight: 50,
        marginBottom:'1%',
        fontFamily: 'Agriculture',
      },
  });
  export default  Wrong;
  